package com.example.mystybag.sharedmodels.project.requestModels.favorites

import com.example.mystybag.sharedmodels.AllCommands.ADD_FAVORITE
import com.example.mystybag.sharedmodels.base.BaseRequestModel
import kotlinx.serialization.Serializable

@Serializable
class AddFavoriteRequestModel(
    val userId            : Long,
    val merchantLocationId: Long
): BaseRequestModel(api = ADD_FAVORITE)